import axios from 'axios'
import i18n from 'i18next'

const parseArr = (val) => {
  if (typeof val === 'string') return [val]
  return val
}

export const getProperties = async (params) => {
  try {
    let cityQuery = '',
      neighborhoodQuery = '',
      postcodeQuery = '',
      addressQuery = '',
      categoryQuery = '',
      roomQuery = ''

    const cityArr = parseArr(params.city)
    const neighborhoodArr = parseArr(params.neighborhood)
    const postcodeArr = parseArr(params.postcode)
    const addressArr = parseArr(params.address)
    const categoryArr = parseArr(params.category)
    const roomArr = parseArr(params.room)
    const searchArr = parseArr(params.search)

    if (cityArr && cityArr.length > 0)
      cityArr.forEach((item) => {
        cityQuery += `&city=${encodeURI(item)}`
      })
    if (neighborhoodArr && neighborhoodArr.length > 0)
      neighborhoodArr.forEach((item) => {
        neighborhoodQuery += `&neighborhood=${encodeURI(item)}`
      })
    if (postcodeArr && postcodeArr.length > 0)
      postcodeArr.forEach((item) => {
        postcodeQuery += `&postcode=${item}`
      })
    if (addressArr && addressArr.length > 0)
      addressArr.forEach((item) => {
        addressQuery += `&address=${encodeURI(item)}`
      })
    if (categoryArr && categoryArr.length > 0)
      categoryArr.forEach((item) => {
        categoryQuery += `&category=${item}`
      })
    if (roomArr && roomArr.length > 0)
      roomArr.forEach((item) => {
        roomQuery += `&room=${item}`
      })
    if (searchArr && searchArr.length > 0)
      searchArr.map((searchTerm) => {
        searchQuery += `&search=${encodeURI(searchTerm)}`
      })

    const { data } = await axios.get(
      `${process.env.GATSBY_BLOK_APP_URL}/api/v2/listings/data/?${cityQuery}${neighborhoodQuery}${postcodeQuery}${addressQuery}${categoryQuery}${roomQuery}`,
      {
        params: {
          country: params.country,
          type: params.type,
          _language: params._language ? params._language : 'en',
          sold: params.sold,
          new: params.new,
          page: params.page,
          page_size: params.page_size,
          order_by: params.order_by,
          area__lte: params.area?.lte,
          area__gte: params.area?.gte,
          price__gte: params.price?.gte,
          price__lte: params.price?.lte,
        },
      }
    )

    return data
  } catch (error) {
    return error.message
  }
}

export const getProperty = async (slug) => {
  const { data } = await axios.get(
    `${process.env.GATSBY_BLOK_APP_URL}/api/v2/listings/data/${slug}/`,
    {
      params: {
        _language: i18n.language ?? 'en',
      },
    }
  )

  return data
}

export const getSimilarPropertiesBySlug = async (slug) => {
  try {
    const { data } = await axios.get('/api/get-similar-apartments-by-slug?slug=' + slug)
    return data
  } catch (error) {
    return error.message
  }
}

export const getSimilarProperties = async (params) => {
  params = new URLSearchParams(params).toString()
  try {
    const { data } = await axios.get('/api/get-similar-apartments?' + params)
    return data
  } catch (error) {
    return error.message
  }
}
